import ky from 'ky';

import type { components } from '@app/api/proxy/openApi.types';

import { clientProxyBaseUrl, punterPreferencesPath } from './path';

export type PunterPreferencesRecord = components['schemas']['PunterPreferencesResponse'];

export type PunterPreferencesRequest = {
  tenantUuid: string;
  punterId: string;
  token: string;
};

export async function fetchPunterPreferences(
  params: PunterPreferencesRequest,
): Promise<PunterPreferencesRecord | null> {
  const baseUrl = clientProxyBaseUrl();
  if (!baseUrl || !params.token) return null;

  try {
    return await ky
      .get(`${baseUrl}${punterPreferencesPath(params.tenantUuid, params.punterId)}`, {
        headers: { Authorization: `Bearer ${params.token}` },
      })
      .json<PunterPreferencesRecord>();
  } catch (error) {
    console.log('An error occurred while getting punter preferences. Error: ', error);
    return null;
  }
}

export async function savePunterPreferences(
  params: PunterPreferencesRequest & { preferences: PunterPreferencesRecord },
): Promise<boolean> {
  const baseUrl = clientProxyBaseUrl();
  if (!baseUrl || !params.token) return false;

  try {
    await ky.post(`${baseUrl}${punterPreferencesPath(params.tenantUuid, params.punterId)}`, {
      json: params.preferences,
      headers: { Authorization: `Bearer ${params.token}` },
    });
    return true;
  } catch (error) {
    console.log('An error occurred while setting punter preferences. Error: ', error);
    return false;
  }
}
